var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading110_container"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"load-inner load-one"}),_c('div',{staticClass:"load-inner load-two"}),_c('div',{staticClass:"load-inner load-three"}),_c('span',{staticClass:"text"},[_vm._v("Loading...")])])])
}]

export { render, staticRenderFns }